export enum EErrorCode {
  Error_0_offline = 0,
  Error_Return_Url_Not_Provided = 1,
  Error_Account_Is_Not_Reachable = 2,
  Error_400_server_error = 400,
  Error_401_server_error = 401,
  Error_403_server_error = 403,
  Error_404_server_error = 404,
  Error_500_server_error = 500,

  //Validation errors
  //Combine 400 with errorCode from response (e.g., '400' + '132')
  Error_TC_invalid_version = 400132,
}
